@if (error(); as error) {
  <nk-error-alert [error]="error"></nk-error-alert>
}
@if (data$ | async; as data) {
  <h6 class="font-weight-bold">{{ 'tables.screening_entity_log.history' | translate }}</h6>
  <div class="screening-action-card-list-wrapper">
    <nk-card-list
      [cardListConfig]="cardListConfig"
      [data]="data"
      [isLoading]="isLoading()"
      (changePage)="onChangePage($event)">
    </nk-card-list>
  </div>
} @else {
  <nk-progress [isLoading]="true"></nk-progress>
}
